import api from '@/api/axios'

const state = {
  category_tiles: [],
}

const mutations = {
  SET_TILES(state, payload) {
    state.category_tiles = payload
  },
}

const actions = {
  async getCategoryTiles({ commit }) {
    try {
      commit('setLoading', true, { root: true })
      const res = await api.get('/admin/category-tiles')
      commit('SET_TILES', res.data.data)
      commit('setLoading', false, { root: true })
    } catch (error) {
      commit('setLoading', false, { root: true })
      return error
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}

